var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 12.2154,
    width: 24,
    height: 24,
    transform: "rotate(-30 0 12.2154)",
    fill: "url(#pattern0_144_55)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_144_55",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_144_55",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_144_55",
    width: 100,
    height: 100,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAADD0lEQVR4nO2dy4rUQBSGI464cVzougedx/ABVFBw0BfwthLB5xAXoqCCLmYQ9TWk1b3gUvC2lhmX4/2TQEAXk8R0n6ROnfo/6F13Vao+qL9S6VRVlRBCCCHKAVgFrgLPgJfAC+AhsAGspL6+ogAuA9u086GRdSD1tYYHuNUhQmKmBLgyQIbEjAlwGNhZUIjEWNN0pBUSsyzNbGovvgP3gMfAV4mZCOBVS6c++Oc7M+C+xEwAMG/pzLt7fFdixgZ41NKJrzt+IzFjAVxq6bxfwNGe39Zi7gC7A8V8Am4AB0drWK4Axzs6buM/y5AYS4CPLR12e2A5EmMBsDU0R3rKk5hUOdJTrsSkypGe8iUmVY701CExqXKkp66ZxCTKkZ46ZxKTKEd66p5JTKIc6al/JjGJcqQLiUmYI10ULyZljnRRtJjUOdJFkWK85EgXRYnxliNV6WK85kjRYjznSJFicsiRosTklCNFiMkxR8KLyTVHworJPUfCiYmSI2HERMuREGIi5kjWYiLnSJZigIsdOXKkCg6wVr+WAXwbKOYtcGKMCzpWSo6MIOYncK2ypnmFoJgcMRZTSzlVWQJstlT2Blh38FkD9pk22lbMe2D/FDniiS/AdbNG24u5MFWOeOOsWcOHi6m3H2lja6oc8cYT04bbDe9z64okZLn7tnmpQ9YZs4bbDlmbpYX6zihzfrtQP29Zqaa9zqa9ujFc/MbwB3CyskJLJ0stnfw2H0a1uMiii4vvgNNjXJCW350tv+sBlZcHVHqE6+wRrv7k4O9PDmHzg5xERM4PchQRMT/IVUS0/CB3EVHygygics8PoonINT+IKCLH/CCyiJzygxJE5JAflCTCc35Qmgiv+UGpIrzlB6WL8JIfSMRftMWfM7QJpjO0TawztJGyI7TVuDO0Gb8zdFyFM3SgiyN05JEzdCiYM3RsnjN0sKQzdPSqM4CnHYcT1xJ0OHEmh9tLxBgAq8C2ROQx9ZWIVAA3JcIZzUuenyXCEcChZgirZ1fPm0/9Juo5YCX19QkhhBBCVN74AxE7aYXw1vF5AAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.f4bede8e00a336856b1fb190791bdbc6.svg";
export { ForwardRef as ReactComponent };